import { Icon } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './TakeoutFeedback.less';

export default class TakeoutFeedback extends OfficialPage {
  state = {
    complaintReason: [],
    orderId: '',
    deliverType: 0,
    submitData: {
      order_id: '',
      complaint_pics: [],
      complaint_reason_id: '',
      complaint_reason: '',
      complaint_additional_reason: ''
    },
    reasonIndex: '',
    isShowInstruction: false,
    isFromBack: false,
    indemnityExplain: {},
    isTurn: false,
    isShowText: true
  }

  constructor(props) {
    super(props);
    document.title = '问题反馈';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.data.orderId = options.orderId
    this.data.deliverType = options.deliverType
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      this.dataInitial()
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  componentDidHide() { }

  componentWillUnmount() { }

  onPullDownRefresh = () => { }
  onReachBottom = () => { }
  onShareAppMessage = () => { }
  dataInitial = () => {
    this.getBuyerComplaintReason()
  }
  getBuyerComplaintReason = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getBuyerComplaintReason',
      data: {
        deliver_type: this.data.deliverType
      },
      success: function (res) {
        if (res.status === 0) {
          that.setData({
            complaintReason: res.data
          })
        }
      }
    })
  }
  chooseImage = e => {
    var that = this,
      complaint_pics = that.data.submitData.complaint_pics
    if (complaint_pics.length >= 3) {
      app.showModal({
        content: '每个商品最多上传3张图片'
      })
      return
    }
    app.chooseImage(function (images) {
      var data = {}
      data['submitData.complaint_pics'] = complaint_pics.concat(images)
      that.setData(data)
    }, 3 - complaint_pics.length)
  }
  removePic = e => {
    var picIndex = e.currentTarget.dataset.picIndex,
      complaint_pics = this.data.submitData.complaint_pics,
      data = {}
    complaint_pics.splice(picIndex, 1)
    data['submitData.complaint_pics'] = complaint_pics
    this.setData(data)
  }
  chooseReason = e => {
    var chooseIndex = e.currentTarget.dataset.reasonIndex,
      data = {}
    data['submitData.complaint_reason_id'] = chooseIndex
    data['submitData.complaint_reason'] = e.currentTarget.dataset.reasonStr
    data.reasonIndex = chooseIndex
    this.setData(data)
  }
  makeComment = e => {
    var that = this,
      submitData = that.data.submitData
    submitData.order_id = this.data.orderId
    submitData.deliver_type = this.data.deliverType
    if (!submitData.complaint_reason_id) {
      app.showModal({
        content: '选择一个反馈项'
      })
      return
    }
    if (submitData.complaint_pics.length > 3) {
      app.showModal({
        content: '最多上传3张图片'
      })
      return
    }
    that.showInstruction()
    this.data.isTurn = true
  }
  showInstruction = () => {
    this.setData({ isShowInstruction: true })
    this.setData({
      isShowText: false
    })
    if (!this.data.indemnityExplain.account_type) {
      this.getIndemnityExplainParam()
    }
  }
  hideInstruction = () => {
    let that = this
    this.setData({
      isShowText: true
    })
    if (this.data.isTurn) {
      this.data.isTurn = false
      var submitData = that.data.submitData
      submitData.order_id = this.data.orderId
      submitData.deliver_type = this.data.deliverType
      app.sendRequest({
        url: '/index.php?r=AppTransport/buyerComplaint',
        method: 'post',
        data: submitData,
        success: function (res) {
          if (res.status === 0) {
            app.turnToPage(
              '/orderMeal/pages/indemnityOrder/indemnityOrder?orderId=' +
              that.data.orderId +
              '&deliverType=' +
              that.data.deliverType,
              1
            )
          }
          that.setData({ isShowInstruction: false })
        },
        complete: function () {
          that.setData({ isShowInstruction: false })
        }
      })
    } else {
      this.setData({ isShowInstruction: false })
    }
  }
  commentInput = e => {
    this.data.submitData.complaint_additional_reason = e.target.value
  }
  getIndemnityExplainParam = () => {
    let submitData = {
      order_id: this.data.orderId
    }
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppTransport/getIndemnityExplainParam',
      method: 'post',
      data: submitData,
      success: function (res) {
        that.setData({
          indemnityExplain: res.data
        })
      }
    })
  }

  render() {
    const {
      rewardPointObj,
      shareGiftsObj,
      collectGiftsObj,
      collectGetObj,
      showGetUserInfo,
      complaintReason,
      reasonIndex,
      isShowText,
      submitData,
      indemnityExplain,
      isShowInstruction
    } = this.state

    return (
      <div className="official-page takeout-feedback">
        <TopNav title="反馈"/>
        <React.Fragment>
          <div className="contain">
            <div className="takeoutFeedback">
              <div className="selectFeedback feedbackItem">
                <span>
                  <span style={convertLineStyleData('color: #F2303E;font-size:28rpx;')}>*</span>
                  请选择反馈项
                </span>
                <span
                  style={convertLineStyleData('color:#FF7100;')}
                  className="fr"
                  onClick={this.showInstruction}
                >
                  赔付说明
                </span>
              </div>
              {Object.values(complaintReason).map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    <div
                      className="feedbackItem"
                      onClick={this.chooseReason}
                      data-reason-index={index}
                      data-reason-str={item}
                    >
                      <span>{item}</span>
                      {index == reasonIndex && (
                        <Icon
                          type="check-circle"
                          color="#FF7100"
                          className="fr"
                        ></Icon>
                      )}
                      {index != reasonIndex && (
                        <label className="circle fr"></label>
                      )}
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
            <div className="takeoutFeedback" style={convertLineStyleData('margin-bottom:40rpx;')}>
              <div style={convertLineStyleData('padding: 30rpx 0;')}>上传凭证（最多上传3张）</div>
              {isShowText && (
                <div className="feedbackInfo">
                  <textarea
                    placeholder="其他补充信息"
                    onInput={this.commentInput}
                  ></textarea>
                </div>
              )}
              <div className="makeCom-pic-container">
                {submitData.complaint_pics.map((imgUrl, index) => {
                  return (
                    <div key className="makeCom-pic-wrap">
                      <img src={imgUrl} mode="aspectFit" />
                      <label
                        className="makeCom-remove-pic"
                        onClick={this.removePic}
                        data-pic-index={index}
                      >
                        ×
                      </label>
                    </div>
                  )
                })}
                {submitData.complaint_pics.length < 3 && (
                  <div className="makeCom-upload-pic" onClick={this.chooseImage}>
                    <div
                      className="ico-moon icon-fn-camera"
                      style={convertLineStyleData('display:block; font-size: 60rpx;')}
                    ></div>
                    <span>添加图片</span>
                  </div>
                )}
              </div>
            </div>
            <div className="bottom-container" onClick={this.makeComment}>
              <label className="make-comment">提交</label>
            </div>
            {isShowInstruction && (
              <div className="instruction-warp">
                <div className="instruction-container">
                  <span className="instruction-title">赔付说明</span>
                  <span className="instruction-item">
                    1.根据实际情况定位骑手还是商家问题，必要时上传产品详情照片1-3张
                  </span>
                  <span className="instruction-item">
                    2.流程：投诉后商家将会收到您的反馈，并在
                    <span style={convertLineStyleData('color:#FF7100;display:inline;')}>1-3</span>
                    {'个工作日内对提交的内容进行审核，审核无误将会赔付金额到您的' +
                      (indemnityExplain.account_type == 1 ? '储值账户' : '') +
                      '中'}
                  </span>
                  <span className="instruction-item">
                    3.最高赔付
                    <span style={convertLineStyleData('color:#FF7100;display:inline;')}>
                      {indemnityExplain.indemnity_fee}
                    </span>
                    元
                  </span>
                  <span className="instruction-item">
                    {'4.若长时间未处理，可拨打热线电话' +
                      (indemnityExplain.contact_phone || '')}
                  </span>
                  <span
                    className="instruction-close"
                    onClick={this.hideInstruction}
                  >
                    知道了
                  </span>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/takeout-feedback/TakeoutFeedback.jsx